import { useState } from "react";
import { GalleryManager } from "@/components/admin/GalleryManager";
import { useSettings } from "@/lib/settings";
import { api } from "@/lib/api";
import { toast } from "sonner";

export const ShopTab = () => {
  const { settings, refresh } = useSettings();
  const [saving, setSaving] = useState(false);
  const on = !!settings.show_prices;

  const toggle = async () => {
    setSaving(true);
    try {
      await api.put("/admin/settings", { show_prices: !on });
      refresh();
      toast.success(!on ? "Prices are now visible on the Shop page." : "Prices are now hidden on the Shop page.");
    } catch {
      toast.error("Couldn't update. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="shop-tab">
      <div className="bg-white border border-line p-5 mb-8 flex items-center justify-between gap-4">
        <div>
          <p className="font-semibold text-sm text-ink">Show prices on the Shop page</p>
          <p className="text-navy/50 text-xs mt-0.5">When off, products display without prices. Set each price below (shown as “from $X”).</p>
        </div>
        <button
          type="button"
          role="switch"
          aria-checked={on}
          disabled={saving}
          onClick={toggle}
          data-testid="show-prices-toggle"
          className={`relative w-14 h-8 rounded-full transition-colors shrink-0 disabled:opacity-60 ${on ? "bg-gold" : "bg-navy/25"}`}
        >
          <span className={`absolute top-1 left-1 w-6 h-6 bg-white rounded-full shadow transition-transform ${on ? "translate-x-6" : "translate-x-0"}`} />
        </button>
      </div>
      <GalleryManager type="shop" />
    </div>
  );
};
